// Individual case-study pages. Only verified stories live here. Add new entries as real
// material (details, outcomes, media) is supplied. Reusable by CaseStudyPage.jsx.

export const CASE_STUDY_PAGES = [
  {
    slug: "gorilla-packaging",
    path: "/work/gorilla-packaging",
    client: "Gorilla Packaging",
    industry: "Food packaging",
    industryPath: "/packaging-marketing-agency",
    title: "Gorilla Packaging Case Study | Viral Vision Media",
    description: "How a content strategy built around their real client work took Gorilla Packaging from invisible and referral-only to 10 Instagram leads within the first few posts.",
    eyebrow: "Case study · Food packaging",
    h1: ["From referral-only to a feed", "that brings in leads."],
    summary: "Gorilla Packaging makes custom packaging locally in Australia. The work was excellent but they were effectively invisible online, relying almost entirely on referrals. We built an organic-only content strategy around the work they'd already done, and within the first few posts they'd picked up 10 Instagram leads.",
    reel: "https://www.instagram.com/reel/Ddsbo1JTPRD/",
    instagram: "https://www.instagram.com/gorillapackagingau/",
    instagramHandle: "@gorillapackagingau",
    sections: [
      ["The situation", "Gorilla Packaging makes custom packaging locally in Australia. The work was excellent, but online they were effectively invisible, relying almost entirely on referrals to win new business."],
      ["What we noticed", "They'd quietly produced a huge amount of impressive work for their clients that nobody outside the room ever got to see. A full portfolio was sitting there, completely hidden from the market."],
      ["The idea", "Build a content strategy made specifically for their business, organic only to start, that put the work they'd already done in front of the right people."],
      ["What we created", "An organic content plan that turned their existing client work into scroll-stopping posts, showing the quality, the range and the custom detail behind every job."],
      ["What happened", "Within the first few posts they'd already picked up 10 Instagram leads and packaging enquiries coming straight through the DMs."],
    ],
    servicesUsed: [
      ["Social Media Marketing", "/social-media-marketing-sydney"],
      ["Content Production", "/content-creation-sydney"],
    ],
  },
];

export const findCaseStudy = (slug) => CASE_STUDY_PAGES.find((c) => c.slug === slug);
